var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceOffered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21H5V15H3V18V21ZM12.46 22L9.53 21.36L6.6 20.67C6.43041 20.6369 6.27805 20.5448 6.17 20.41C6.05824 20.2791 5.99783 20.1121 6 19.94V15.94C6.00283 15.7688 6.06265 15.6034 6.17 15.47C6.28169 15.3394 6.43246 15.2482 6.6 15.21L11.38 14.62L16.17 14.02L16.32 14.58L16.47 15.13C16.4727 15.3144 16.4204 15.4954 16.32 15.65C16.2281 15.8117 16.0884 15.941 15.92 16.02L13.92 16.52L11.92 17.02L13.54 17.68L15.17 18.33L17.44 17.69L19.65 17C19.8464 16.9503 20.0544 16.979 20.23 17.08C20.3184 17.1278 20.3961 17.1933 20.458 17.2724C20.52 17.3516 20.5649 17.4427 20.59 17.54L20.78 18.31L20.98 19.07C21.0254 19.2601 20.9968 19.4602 20.9 19.63C20.7971 19.8013 20.6325 19.9265 20.44 19.98L16.81 20.98L13.18 21.98C13.0605 21.9953 12.9395 21.9953 12.82 21.98C12.7019 22.0064 12.5803 22.0132 12.46 22ZM9 4L7 6L5 8L7 10L9 12L9.7 11.3L10.4 10.6L9.1 9.3L7.8 8L9.1 6.7L10.4 5.4L9.7 4.7L9 4ZM15 4L14.3 4.7L13.6 5.4L14.9 6.7L16.2 8L14.9 9.3L13.6 10.6L14.3 11.3L15 12L17 10L19 8L17 6L15 4Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceOffered);
export default __webpack_public_path__ + "static/media/service-offered.529b38b08538b06d00f7cf8e6e694179.svg";
export { ForwardRef as ReactComponent };